// extracted by mini-css-extract-plugin
export default {"markdown-content":"styles_markdown-content__YEMAd","markdownContent":"styles_markdown-content__YEMAd"};